import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function ApprovalModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item,
    loader,
}) {
    const { t } = useTranslation();

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit, setValue } = methods;

    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form >
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">{t("approvalModal.title")}</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards min-height-auto'>
                            <h2 className='text-center lh-base'>{t("approvalModal.message", { amount: item?.appointment_details?.extra_mileage })}
                                <br />
                                {t("approvalModal.question")}
                            </h2>
                            <div className="d-flex gap-3 mb-3">
                                <button
                                    type="button"
                                    onClick={handleSubmit(() => onConfirm({ extra_mileage_request: 1 }, "mileage-approval"))}
                                    disabled={loader}
                                    className={'main_button green'}
                                >
                                    {t("approvalModal.approve")}
                                </button>

                                <button
                                    type="button"
                                    onClick={handleSubmit(() => onConfirm({ extra_mileage_request: 0 }, "mileage-approval"))}
                                    disabled={loader}
                                    className={'main_button tomatoRed'}
                                >
                                    {t("approvalModal.decline")}
                                </button>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="Cancle_button" type='button' onClick={onClose}>{t("translation.close")}</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default ApprovalModal;